import React from "react";
import styles from "./styles.module.scss"; // Ensure skeleton styles are added here

const SkeletonBookingCard = ({ layout }) => {
  return (
    <div className={`${styles.bookingCardSkeleton} ${styles[layout]}`}>
      <div className={styles.header}>
      </div>
      <div className={styles.section1}>
        <div className={styles.images}>
          <div className={styles.imageSkeleton}></div>
        </div>
        <div className={styles.details}>
          <div className={styles.detailsHeader}>
            <div className={styles.titleSkeleton}></div>
            <div className={styles.idSkeleton}></div>
          </div>
          <div className={styles.detailsMain}>
            <div className={styles.textSkeleton}></div>
            <div className={styles.textSkeleton}></div>
            <div className={styles.valueSkeleton}></div>
          </div>
          <div className={styles.detailsAddress}>
            <div className={styles.iconSkeleton}></div>
            <div className={styles.addressSkeleton}></div>
          </div>
        </div>
        <div className={styles.statusSkeleton}></div>
      </div>

      <div className={styles.footer}>
        <div className={styles.footerButtonSkeleton}></div>
      </div>
    </div>
  );
};

export default SkeletonBookingCard;
